import { Messages } from '../../../../codegen/Localize';
import { IBackgroundJobInfo } from '../../../../ts/resources/BackgroundJobs';
import { ICancelBackgroundJobAction } from '../../../../ts/ServerApi/types/actionNames';
import { openCancelBackgroundJobDialogAction } from '../../../actions/spaces/OpenCancelBackgroundJobDialogAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

// Confusingly, the UI cancel background job action does not map directly to the redux action, as the UI
// prompts the user for details and confirmation, whilst the redux action simply executes the cancellation
export const CancelBackgroundJobAction: IEntityAction<IBackgroundJobInfo, ICancelBackgroundJobAction> = {
  name: EntityActionNames.CancelBackgroundJob,
  translateName: Messages.cancel,
  isVisible: () => true, // probably need to do something here
  isClickable: (availableActions: ICancelBackgroundJobAction) => !!(availableActions && availableActions.cancelBackgroundJob),
  createReduxAction: (targetItems: IBackgroundJobInfo[]) => openCancelBackgroundJobDialogAction(targetItems[0])
};
